import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchTasks } from './store/slices/tasksSlice.js';
import Header from './components/Layout/Header.jsx';
import FilterBar from './components/Filters/FilterBar.jsx';
import StatsBar from './components/Layout/StatsBar.jsx';
import KanbanBoard from './components/Board/KanbanBoard.jsx';
import TaskModal from './components/TaskModal/TaskModal.jsx';
import ConfirmDialog from './components/TaskModal/ConfirmDialog.jsx';
import ToastContainer from './components/Layout/ToastContainer.jsx';

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTasks());
  }, [dispatch]);

  return (
    <div className="app">
      <Header />
      <FilterBar />
      <StatsBar />
      <KanbanBoard />
      <TaskModal />
      <ConfirmDialog />
      <ToastContainer />
    </div>
  );
}
